import { WebinarActionsProps } from './types';

export const WebinarActions = ({ children }: WebinarActionsProps) => (
    <div className="flex gap-4">{children}</div>
);
